var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#fff;opacity:0.31;}")),React.createElement("path",{"className":"a","d":"M36.43,51.5a15.571,15.571,0,0,1-4.3,1.179,7.427,7.427,0,0,0,3.286-4.128,14.925,14.925,0,0,1-4.736,1.808A7.468,7.468,0,0,0,17.757,55.47a7.69,7.69,0,0,0,.173,1.7A21.139,21.139,0,0,1,2.536,49.362a7.47,7.47,0,0,0,2.3,9.982,7.376,7.376,0,0,1-3.374-.92v.082a7.5,7.5,0,0,0,5.984,7.338,7.454,7.454,0,0,1-1.958.246,6.6,6.6,0,0,1-1.414-.128,7.54,7.54,0,0,0,6.979,5.2,15.006,15.006,0,0,1-9.26,3.185A13.989,13.989,0,0,1,0,74.248,21.026,21.026,0,0,0,11.457,77.6c13.743,0,21.257-11.384,21.257-21.252,0-.33-.011-.649-.027-.965A14.9,14.9,0,0,0,36.43,51.5Z","transform":"translate(0 -48)","key":1})]);
}

Twitter.defaultProps = {"viewBox":"0 0 36.43 29.599"};

module.exports = Twitter;

Twitter.default = Twitter;
